import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FiltersControls, Pagination, Spinner, BoxList } from 'components';
import {
  loadIpmaRegOfficeCoursesCreator,
  setIpmaRegOfficeCoursesPageCreator,
  setIpmaRegOfficeCoursesPerPageCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';
import { CourseButtonAction, Flex } from '../CoursesProgrammes.styled';
import UploadModal from '../UploadModal/UploadModal';
import AcceptModal from '../AcceptModal/AcceptModal';

const Rejected = ({ courses, page, pages, perPage, loading, loadCourses, setPage, setPerPage }) => {
  const { t } = useTranslation();
  const [acceptModal, setAcceptModal] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);

  useEffect(() => {
    setPage(1);
  }, [perPage]);

  useEffect(() => {
    loadCourses({ status: 'canceled' });
  }, [perPage, page]);

  return (
    <>
      <FiltersControls
        perPageSelected={perPage}
        perPageOnChange={({ value }) => setPerPage(value)}
      />
      {loading ? <Spinner /> : null}
      {!loading ? (
        <>
          <BoxList
            type="course"
            items={courses}
            alert={t('global.noResultsFound')}
            customRenderActions={({ item }) => (
              <Flex>
                <CourseButtonAction
                  icon="upload"
                  title={t('global.uploadEditRegLogo')}
                  verticalviewbreakpoint="xl"
                  onClick={() => setUploadModal(item.id)}
                />
                <CourseButtonAction
                  icon="checkCircle"
                  title={t('global.acceptButton')}
                  verticalviewbreakpoint="xl"
                  disabled={!item.regLogoZipFile && !item.googleFileUrl}
                  onClick={() => setAcceptModal(item)}
                />
              </Flex>
            )}
          />
          <Pagination styled currentPage={page} totalPages={pages} onChange={setPage} />
        </>
      ) : null}
      <AcceptModal status="pending" open={acceptModal} setOpen={setAcceptModal} />
      <UploadModal
        files={filesToUpload}
        open={uploadModal}
        setFiles={setFilesToUpload}
        setOpen={setUploadModal}
      />
    </>
  );
};

Rejected.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  loadCourses: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, loading }) => ({
  courses: ipma.regOfficeCourses.list.items,
  page: ipma.regOfficeCourses.list.page,
  pages: ipma.regOfficeCourses.list.pages,
  perPage: ipma.regOfficeCourses.list.perPage,
  loading: isLoading(loading, 'IPMA'),
});
const mapDispatchToProps = (dispatch) => ({
  loadCourses: (payload) => dispatch(loadIpmaRegOfficeCoursesCreator(payload)),
  setPage: (payload) => dispatch(setIpmaRegOfficeCoursesPageCreator(payload)),
  setPerPage: (payload) => dispatch(setIpmaRegOfficeCoursesPerPageCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rejected);
